import React, { useState } from 'react';
import { Server, Smartphone, Monitor, Database, Cloud, Shield, Wrench, Box, GitBranch, BarChart } from 'lucide-react';

const TechStackClassifier = () => {
  const categories = {
    backend: {
      name: 'Backend',
      icon: Server,
      color: 'bg-blue-500',
      items: [
        'Spring Boot',
        'Spring Web',
        'Spring Data JPA',
        'Spring Security 6',
        'Spring Cloud',
        'Spring Boot Actuator',
        'Java & Spring',
        'GO',
        'Bun',
        'Flyway migracion'
      ]
    },
    frontend: {
      name: 'Frontend Web',
      icon: Monitor,
      color: 'bg-purple-500',
      items: [
        'Nuxt',
        'Vue',
        'Pinia',
        'Vite',
        'TypeScript',
        'Cloudflare Pages'
      ]
    },
    mobile: {
      name: 'Mobile',
      icon: Smartphone,
      color: 'bg-green-500',
      items: [
        'Flutter',
        'Dart'
      ]
    },
    infrastructure: {
      name: 'Infraestructura & Orquestación',
      icon: Cloud,
      color: 'bg-orange-500',
      items: [
        'Kubernetes',
        'EKS',
        'Amazon ECS',
        'Docker',
        'Docker Compose'
      ]
    },
    database: {
      name: 'Bases de Datos & Mensajería',
      icon: Database,
      color: 'bg-red-500',
      items: [
        'Kafka',
        'AWS SQS'
      ]
    },
    security: {
      name: 'Seguridad & Acceso',
      icon: Shield,
      color: 'bg-yellow-500',
      items: [
        'Cloudflare Access',
        'Cloudflare WAF',
        'Cloudflare Turnstile',
        'Cloudflare API Shield',
        'Protección DDoS de Cloudflare',
        'AWS Secrets Manager'
      ]
    },
    networking: {
      name: 'Networking & CDN',
      icon: Box,
      color: 'bg-teal-500',
      items: [
        'Cloudflare DNS + Proxy',
        'Cloudflare Tunnel',
        'Amazon Gateway'
      ]
    },
    devops: {
      name: 'DevOps & CI/CD',
      icon: GitBranch,
      color: 'bg-indigo-500',
      items: [
        'GitHub Actions / GitLab CI',
        'coderabbit'
      ]
    },
    monitoring: {
      name: 'Monitoreo & Observabilidad',
      icon: BarChart,
      color: 'bg-pink-500',
      items: [
        'Sentry',
        'Amazon CloudWatch',
        'Cloudflare Analytics / Security',
        'Amazon Athena'
      ]
    },
    tools: {
      name: 'Herramientas & Utilidades',
      icon: Wrench,
      color: 'bg-gray-500',
      items: [
        'JetBrains',
        'OpenAPI / springdoc-openapi',
        'Python + Jupyter + Pandas',
        'Resend'
      ]
    }
  };

  const [selectedCategory, setSelectedCategory] = useState(null);

  return (
    <div className="w-full max-w-6xl mx-auto p-6 bg-gradient-to-br from-gray-50 to-gray-100 rounded-xl">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-2">Stack Tecnológico Clasificado</h1>
        <p className="text-gray-600">Organización de tecnologías por categoría funcional</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {Object.entries(categories).map(([key, category]) => {
          const Icon = category.icon;
          const isSelected = selectedCategory === key;
          
          return (
            <div
              key={key}
              className={`bg-white rounded-lg shadow-md hover:shadow-lg transition-all cursor-pointer border-2 ${
                isSelected ? 'border-blue-500 scale-105' : 'border-transparent'
              }`}
              onClick={() => setSelectedCategory(isSelected ? null : key)}
            >
              <div className={`${category.color} text-white p-4 rounded-t-lg flex items-center gap-3`}>
                <Icon size={24} />
                <div>
                  <h3 className="font-bold text-lg">{category.name}</h3>
                  <span className="text-sm opacity-90">{category.items.length} tecnologías</span>
                </div>
              </div>
              
              <div className={`p-4 transition-all ${isSelected ? 'max-h-96' : 'max-h-48'} overflow-y-auto`}>
                <ul className="space-y-2">
                  {category.items.map((item, index) => (
                    <li key={index} className="flex items-start gap-2 text-gray-700">
                      <span className="text-blue-500 mt-1">•</span>
                      <span className="text-sm">{item}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          );
        })}
      </div>

      <div className="mt-8 p-6 bg-white rounded-lg shadow-md">
        <h2 className="text-xl font-bold text-gray-800 mb-4">📊 Resumen del Stack</h2>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
          {Object.entries(categories).map(([key, category]) => (
            <div key={key} className="text-center">
              <div className={`${category.color} text-white rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-2`}>
                {category.items.length}
              </div>
              <p className="text-xs text-gray-600 font-medium">{category.name}</p>
            </div>
          ))}
        </div>
      </div>

      <div className="mt-6 p-4 bg-blue-50 rounded-lg border border-blue-200">
        <p className="text-sm text-blue-800">
          💡 <strong>Tip:</strong> Haz clic en cualquier categoría para expandir/contraer la lista completa de tecnologías.
        </p>
      </div>
    </div>
  );
};

export default TechStackClassifier;